import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { sidebarMenus } from '../../../shared/constants/sidebar-menu.constant';
import {
  IDeployVersion,
  ISidebarMenu,
  ISubMenu,
} from '../../models/interface/sidebar/sidebar-menu';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly fullMenu = sidebarMenus;

  private isOpenSideBarSubject = new BehaviorSubject<boolean>(false);
  isOpenSideBar$ = this.isOpenSideBarSubject.asObservable();

  private lddUrlBase = environment.url.lddServiceApiUrl;

  constructor(private http: HttpClient) {}

  getApiCurrentVersion(): Observable<IDeployVersion> {
    const currentApiVersion = `${this.lddUrlBase}${environment.url.updateApiVersion.currentApiVersion}`;
    return this.http.get<IDeployVersion>(currentApiVersion);
  }

  toggleSidebar() {
    this.isOpenSideBarSubject.next(!this.isOpenSideBarSubject.value);
  }

  setSidebarState(state: boolean) {
    this.isOpenSideBarSubject.next(state);
  }

  getMenuByPermissions(
    subMenuIds: number[],
    viewAbleChildrenSubMenuIds: number[]
  ): ISidebarMenu[] {
    return this.fullMenu
      .map((main) => ({
        ...main,
        mainMenus: this.updateMainMenus(
          main.mainMenus,
          subMenuIds,
          viewAbleChildrenSubMenuIds
        ),
      }))
      .filter((main) => {
        return (
          main.mainMenus.length > 0 ||
          (main.mainMenus.length === 0 &&
            subMenuIds.includes(main.subMenuId || -1))
        );
      });
  }

  updateMainMenus(
    menu: ISubMenu[],
    subMenuIds: number[],
    viewAbleChildrenSubMenuIds: number[]
  ): ISubMenu[] {
    return menu
      .filter((mn) => subMenuIds.includes(mn.subMenuId))
      .map((menuItem) => {
        if (!Array.isArray(menuItem.subMenus)) {
          return { ...menuItem };
        }

        const filteredSubMenus = menuItem.subMenus.filter(
          (child) =>
            child && viewAbleChildrenSubMenuIds.includes(child.childSubMenuId)
        );

        if (filteredSubMenus.length === 0) {
          const { subMenus, ...rest } = menuItem;
          return rest;
        }

        return {
          ...menuItem,
          subMenus: filteredSubMenus,
        };
      });
  }
}
